import React, { FC, ReactElement } from 'react';
import { BottomNavigation } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useInitialRouterNavigation } from 'core/router/router';

import { BottomNavItemProps } from './BottomNavItem';

export interface BottomNavProps {
    children: ReactElement<BottomNavItemProps>[];
    className?: string;
}

const useBottomNavigationStyles = makeStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.brandPrimary.accent}`,
    },
}));

export const BottomNav: FC<BottomNavProps> = props => {
    const [value, setValue] = useInitialRouterNavigation(props.children.map(c => c.props.to));
    const classes = useBottomNavigationStyles();
    return <BottomNavigation classes={classes} value={value} onChange={(_, v) => setValue(v)} {...props} />;
};
